module.exports = process.env.NODE_ENV === 'test'
  ? require('./src/immutable')
  : require('./lib/immutable');



//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/immutable.js
// module id = 17
// module chunks = 0